import React from "react";
import { Navigate, useParams } from "react-router-dom";

type LegacyUserRedirectProps = {
  /** Path appended after the user id, e.g. "/edit". */
  suffix?: string;
};

/**
 * User pages used to live at "/users/profile/:id" and "/users/edit/:id".
 * They now nest under the user itself ("/users/:id" and "/users/:id/edit"),
 * so the old paths stay around as redirects: bookmarks, shared links and
 * already-open tabs keep working.
 */
const LegacyUserRedirect: React.FC<LegacyUserRedirectProps> = ({
  suffix = "",
}) => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <Navigate to="/users" replace />;
  }

  return <Navigate to={`/users/${id}${suffix}`} replace />;
};

export default LegacyUserRedirect;
